import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';

const UnitDetail = ({ title, documentUrl, unitClassName }) => (
	<p><a href={documentUrl} target="_blank" className={unitClassName}>{title}</a></p>
);

UnitDetail.propTypes = {
    title: PropTypes.string,
    documentUrl: PropTypes.string,
    unitClassName: PropTypes.string
};

export default UnitDetail;
